export const DIGIT_SPACE_DASH_LATIN_GEORGIAN_ONLY_REGEX =
  /^[a-zA-Zა-ჰ0-9  ,.;#\-—/&*\s-]*$/;

export const GEO_LAT_LETTERS_ONLY = /^[a-zA-Zა-ჰ\s]*$/;

export const NUMBERS_ONLY_REGEX = /^[0-9]*$/;

export const LATIN_LETTERS_WITH_NUMBERS = /^[a-zA-Z0-9]*$/;
